import { CssBaseline, MuiThemeProvider, createMuiTheme } from 'material-ui';
import React, { Component } from 'react';
import loadJSON from './utils/JSONLoader';
import NavHeader from './components/NavHeader';
import Message from './components/Message';
import Settings from './Settings';
import { Redirect, Route, Switch } from 'react-router-dom';
import Resources from './Resources';
import SingleResource from './SingleResource';

const getDefaultManifestURLs = () => {return[
  'https://david476.github.io/ofr-testing_bundle/manifest.json'
]};

const getEmptyAppManifestState = () => {return {
  manifestURLs: [],//An array of strings storing the URLs of the current manifests in the order they should be merged.
  manifestStates: {},//An object where keys are manifest URLs (not necessarily current ones but must unclude current ones) and values are objects. Objects contain a 'load' key with value of 'unloaded', 'loading', 'loaded', or 'errored', optionally a 'lastLoad' key with value of the Date when the manifest was last successfully loaded, and optionally a 'lastError' key with value of the Date when the manifest load last errored.
  manifests: {},//An object where keys are manifest URLs (not necessarily current ones, only guaranteed to exist if this.state.manifestStates[url].load is 'loaded') and values are the parsed contents of the manifests.
  resources: {},//An object where keys are resourceIDs from the manifests and their corresponsing ResourceInfo objects.
  featured: []
}};

class App extends Component {
  theme = createMuiTheme({
    palette: {background: {default: '#f0f0f0'}}
  });

  constructor(props) {
    super(props);
    this.state = getEmptyAppManifestState();
  }

  render() {
    return (
      <MuiThemeProvider theme={this.theme}>
        <CssBaseline/>
        <NavHeader/>
        <Switch>
          <Route exact path="/">
            <Message>Home</Message>
          </Route>
          <Route exact path="/resources">
            <Resources resources={this.state.resources} featured={this.state.featured}/>
          </Route>
          <Route path="/resources/:resourceID" render={(props)=>{
            return <SingleResource resourceID={props.match.params.resourceID} resources={this.state.resources}/>;
          }}/>
          <Route path="/glossary">
            <Message>Glossary</Message>
          </Route>
          <Route path="/settings">
            <Settings app={this} manifestURLs={this.state.manifestURLs} manifestStates={this.state.manifestStates} manifests={this.state.manifests} />
          </Route>
          <Route><Redirect to="/"/></Route>
        </Switch>
      </MuiThemeProvider>
    );
  }

  componentWillMount() {
    this.initializeDefaultAppManifestState(()=>{
      var loaded = this.loadAppManifestState(()=>{
        this.loadMergeAndSaveCurrentManifests();
      });
      if(!loaded) {
        this.saveAppManifestState();
        this.loadMergeAndSaveCurrentManifests();
      }
    });
  }

  /**
   * Resets this.state.manifestURLs/manifestStates/manifests/documents/terms to empty and then calls setManifestURLs with the default URLs.
   * Optional callback called once the default manifest URLs have been set up.
   */
  initializeDefaultAppManifestState(callback=()=>{}) {
    this.setState(getEmptyAppManifestState(), ()=>{
      this.setManifestURLs(getDefaultManifestURLs(), callback);
    });
  }

  /**
   * Attempts to populate this.state.manifestURLs/manifestStates/manifests/documents/terms from localStorage.
   * Optional callback called when this.state is updated.
   * Returns true if able to load and parse the data from localStorage, otherwise false.
   */
  loadAppManifestState(callback=()=>{}) {
    try{
      console.log('Loading app manifest state...');
      var manifestURLs = JSON.parse(window.localStorage.getItem('manifestURLs'));
      var manifestStates = JSON.parse(window.localStorage.getItem('manifestStates'));
      var manifests = JSON.parse(window.localStorage.getItem('manifests'));
      var resources = JSON.parse(window.localStorage.getItem('resources'));
      var featured = JSON.parse(window.localStorage.getItem('featured'));
      if(manifestURLs != null && manifestStates != null && manifests != null && resources != null && featured != null) {
        this.setState({
          manifestURLs: manifestURLs,
          manifestStates: manifestStates,
          manifests: manifests,
          resources: resources,
          featured: featured
        }, ()=>{
          console.log('App manifest state loaded!');
          callback();
        });
        return true;
      }
    }catch(e) {
      console.log('Failed to load app manifest state!', e);
    }

    return false;
  }

  /**
   * Attempts to save this.state.manifestURLs/manifestStates/manifests/documents/terms to localStorage.
   * Returns true if able to stringify and save the data to localStorage, otherwise false.
   */
  saveAppManifestState() {
    try{
      console.log('Saving app manifest state...');
      window.localStorage.setItem('manifestURLs', JSON.stringify(this.state.manifestURLs));
      window.localStorage.setItem('manifestStates', JSON.stringify(this.state.manifestStates));
      window.localStorage.setItem('manifests', JSON.stringify(this.state.manifests));
      window.localStorage.setItem('resources', JSON.stringify(this.state.resources));
      window.localStorage.setItem('featured', JSON.stringify(this.state.featured));
      return true;
    }catch(e) {
      console.log('Failed to save app manifest state!', e);
    }

    return false;
  }

  /**
   * Sets this.state.manifestURLs and makes sure that this.state.manifestStates is properly configured.
   * Optional callback is run after this.state has been updated.
   */
  setManifestURLs(urls, callback=()=>{}) {
    var newManifestStates = this.state.manifestStates;
    for(var i in urls) {
      if(!newManifestStates[urls[i]]) {
        newManifestStates[urls[i]] = {
          load: 'unloaded'
        };
      }
    }

    this.setState({
      manifestURLs: urls,
      manifestStates: newManifestStates
    }, callback);
  }

  /**
   * Sets the manifestURLs, makes sure that this.state.manifestStates is properly configured, and then saves app manifest state to localStorage.
   * Optional callback called with the result of saveAppManifestState.
   */
  setAndSaveManifestURLs(urls, callback=(saved)=>{console.log('Manifests set. Saved?', saved);}) {
    this.setManifestURLs(urls, ()=>{
      callback(this.saveAppManifestState());
    });
  }

  /**
   * Attempts to start the (re)loading process for all current manifest URLs.
   * Whenever one has loaded, all current manifests are remerged.
   * Whenever manifests are merged, app manifest state is saved to localStorage.
   */
  loadMergeAndSaveCurrentManifests() {
    for(var i in this.state.manifestURLs) {
      this.loadManifest(this.state.manifestURLs[i], ()=>{
        this.mergeManifests(()=>{
          this.saveAppManifestState();
        });
      })
    }
  }

  /**
   * Asynchronously (re)loads the manifest at that URL, updating this.state.manifestStates[url] and this.state.manifests[url].
   * Optional onSuccess callback called after this.state has been updated.
   * Optional onFail callback called after this.state has been updated with 'retrieve', 'timeout', or 'parse'. 
   * Optional timeout is the maximum number of milliseconds the HTTP request can take.
   */
  loadManifest(url, onSuccess=()=>{}, onFail=(type)=>{console.error('Manifest load failed', url, type)}, timeout=7500) {
    var loadingStateUpdate = {
      manifestStates: this.state.manifestStates
    }
    loadingStateUpdate.manifestStates[url].load = 'loading';

    this.setState(loadingStateUpdate, ()=>{
      loadJSON(url, manifest=>{
        //TODO verify manifest format is proper, this might be interesting: http://json-schema.org/
        var stateUpdate = {
          manifestStates: this.state.manifestStates,
          manifests: this.state.manifests
        }
        stateUpdate.manifestStates[url].load = 'loaded';
        stateUpdate.manifestStates[url].lastLoad = new Date();
        stateUpdate.manifests[url] = manifest;
        this.setState(stateUpdate, ()=>{
          onSuccess();
        });
  
      }, failType => {
        var stateUpdate = {
          manifestStates: this.state.manifestStates
        }
        stateUpdate.manifestStates[url].load = 'errored';
        stateUpdate.manifestStates[url].lastError = new Date();
        this.setState(stateUpdate, ()=>{
          onFail(failType);
        });
  
      }, timeout, true);

    });
  }

  /**
   * Returns true if any manifest load state is 'errored'
   */
  anyManifestLoadErrored() {
    for(var url in this.state.manifestStates)
      if(this.state.manifestStates[url].load === 'errored')
        return true;

    return false;
  }

  /**
   * Merges all the available current manifests (including if their last load errored), (re)populates this.state.terms and this.state.documents.
   * Optional callback called once this.state has been updated.
   */
  mergeManifests(callback=()=>{}) {
    var manifestURLs = this.state.manifestURLs;
    var manifests = this.state.manifests;
    var mergedResources = {};
    var mergedFeatured = [];

    for(var i in manifestURLs) {
      var manifest = manifests[manifestURLs[i]];
      if(manifest) {
        for(var resourceID in manifest.resources) {
          mergedResources[resourceID] = manifest.resources[resourceID];
        }
        if(manifest.featured) {
          mergedFeatured = mergedFeatured.concat(manifest.featured);
        }
      }
    }
    this.setState({
      resources: mergedResources,
      featured: mergedFeatured
    }, callback);
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js